(() => {
  const elementName = 'loop-delivery-timeline';

  if (customElements.get(elementName)) return;

  const dayMs = 86400000;
  const holidayCache = new Map();

  const utcDate = (year, month, day) => new Date(Date.UTC(year, month - 1, day, 12));

  const addCalendarDays = (date, days) => {
    const result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  };

  const dateKey = (date) => {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  };

  const easterSunday = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return utcDate(year, month, day);
  };

  const holidaysFor = (year) => {
    if (holidayCache.has(year)) return holidayCache.get(year);

    const holidays = new Set();
    [
      [1, 1],
      [5, 1],
      [5, 8],
      [7, 14],
      [8, 15],
      [11, 1],
      [11, 11],
      [12, 25]
    ].forEach(([month, day]) => holidays.add(dateKey(utcDate(year, month, day))));

    const easter = easterSunday(year);
    [1, 39, 50].forEach((offset) => holidays.add(dateKey(addCalendarDays(easter, offset))));

    holidayCache.set(year, holidays);
    return holidays;
  };

  const isBusinessDay = (date) => {
    const weekday = date.getUTCDay();
    if (weekday === 0 || weekday === 6) return false;
    return !holidaysFor(date.getUTCFullYear()).has(dateKey(date));
  };

  const addBusinessDays = (date, count) => {
    let result = new Date(date.getTime());
    let remaining = count;

    while (remaining > 0) {
      result = addCalendarDays(result, 1);
      if (isBusinessDay(result)) remaining -= 1;
    }

    return result;
  };

  const parisToday = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());

    const value = (type) => Number(parts.find((part) => part.type === type).value);
    return utcDate(value('year'), value('month'), value('day'));
  };

  const monthName = (date) =>
    new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'UTC',
      month: 'long'
    }).format(date);

  const formatDate = (date) =>
    new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'UTC',
      day: 'numeric',
      month: 'long'
    }).format(date);

  const formatRange = (start, end) => {
    if (dateKey(start) === dateKey(end)) return formatDate(start);

    const sameMonth =
      start.getUTCFullYear() === end.getUTCFullYear() &&
      start.getUTCMonth() === end.getUTCMonth();

    if (sameMonth) {
      return start.getUTCDate() + '–' + end.getUTCDate() + ' ' + monthName(end);
    }

    return formatDate(start) + '–' + formatDate(end);
  };

  class LoopDeliveryTimeline extends HTMLElement {
    connectedCallback() {
      this.updateDates();
      window.clearInterval(this._loopDateTimer);
      this._loopDateTimer = window.setInterval(() => this.updateDates(), dayMs / 24);
    }

    disconnectedCallback() {
      window.clearInterval(this._loopDateTimer);
    }

    updateDates() {
      const orderDate = parisToday();
      const shippingDate = addBusinessDays(orderDate, 1);
      const deliveryDate = addBusinessDays(shippingDate, 3);

      const orderText = formatDate(orderDate);
      const shippingText = formatDate(shippingDate);
      const deliveryText = formatDate(deliveryDate);

      const orderNode = this.querySelector('[data-loop-date="order"]');
      const shippingNode = this.querySelector('[data-loop-date="shipping"]');
      const deliveryNode = this.querySelector('[data-loop-date="delivery"]');

      if (orderNode) orderNode.textContent = orderText;
      if (shippingNode) shippingNode.textContent = shippingText;
      if (deliveryNode) deliveryNode.textContent = deliveryText;

      this.setAttribute(
        'aria-label',
        'Commande le ' + orderText +
          ', expédition estimée le ' + shippingText +
          ', livraison estimée le ' + deliveryText
      );
    }
  }

  customElements.define(elementName, LoopDeliveryTimeline);
})();